export const MAX_RECENTLY_VIEWED_VEHICLE_TILES = 10;
export const KMX_PHONE_BP = 390;
